// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"r3-z","displaySixCardTiles":"s3-z"};